import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem, FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '../theme/tokens';

const StyledSelect = styled(Select)({
  backgroundColor: '#ffffff',
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: '500',
  color: colors.primary.main,
  border: '2px solid #e2e8f0',
  minWidth: '150px',
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover': {
    backgroundColor: '#f1f5f9',
    borderColor: colors.secondary.main,
  },
  '&.Mui-focused': {
    borderColor: colors.primary.main,
  }
});

const LanguageOption = styled(MenuItem)({
  fontSize: '15px',
  fontWeight: '500',
  padding: '12px 16px',
  '&:hover': {
    backgroundColor: '#f0f4ff',
  },
  '&.Mui-selected': {
    backgroundColor: '#e3f2fd',
    '&:hover': {
      backgroundColor: '#d1e9fc',
    }
  }
});

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (event) => {
    const newLanguage = event.target.value;
    i18n.changeLanguage(newLanguage);

    // Update HTML dir attribute for RTL/LTR
    document.documentElement.dir = newLanguage === 'ar' || newLanguage === 'he' ? 'rtl' : 'ltr';
  };

  const languages = [
    { code: 'en', label: '🇺🇸 English', nativeName: 'English' },
    { code: 'he', label: '🇮🇱 עברית', nativeName: 'עברית' },
    { code: 'ar', label: '🇸🇦 العربية', nativeName: 'العربية' }
  ];

  return (
    <FormControl size="small">
      <StyledSelect
        value={i18n.language}
        onChange={handleLanguageChange}
        displayEmpty
        inputProps={{
          'aria-label': 'Select language',
        }}
      >
        {languages.map((language) => (
          <LanguageOption key={language.code} value={language.code}>
            {language.label}
          </LanguageOption>
        ))}
      </StyledSelect>
    </FormControl>
  );
};

export default LanguageSwitcher;
